import { core, fileUpload, compressImg } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    upload() {
      return $(`
      <div class="upload upload-list--picture-card">
        <div id="cart" tabindex="0" class="upload-list__item upload--picture-card   is-success">
          <div class="img-plus" id="plus">
            <i class="fa fa-plus"></i>
          </div>
          <img id="img" src="" class="upload-list__item-thumbnail">
          <input id="input" type="file" name="file" class="upload__input">
          <label id="successIcon" class="upload-list__item-status-label" style="line-height:12px;">
            <i class="fa fa-check icon-upload-success" style="color:#ffffff;"></i>
          </label>
          <span id="operation" class="upload-list__item-actions">
            <span id="operationPlus" class="upload-list__item-preview" >
              <i class="fa fa-plus" style="color:#ffffff;"></i>
            </span>
            <span id="operationDel" class="upload-list__item-delete">
              <i class="fa fa-trash" style="color:#ffffff;"></i>
            </span>
          </span>
        </div>
      </div>`)
    }
  },
  updater: {
    // 原生属性√: name
    name(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.attr('name', value)
      } else {
        input.removeAttr('name')
      }
    },
    // 原生属性√: disabled
    disabled(value, opt, tar, node) {
      const { input } = tar.members
      if (value || value === '') {
        tar.unit.addClass('is-disabled')
        input.prop('disabled', true)
      } else {
        tar.unit.removeClass('is-disabled')
        input.prop('disabled', false)
      }
    },
    // 基本功能√: 尺寸
    width(value, opt, tar, node) {
      const { cart } = tar.members
      const width = Number(value) || 148
      cart.css({ width: width })
    },
    // 基本功能√: 尺寸
    height(value, opt, tar, node) {
      const { cart, plus } = tar.members
      const height = Number(value) || 148
      cart.css({ height: height, 'line-height': height - 2 + 'px' })
    },
    // 基本功能: 选中状态的值
    value(value, opt, tar, node) {
      const { plus, img, successIcon, operation } = tar.members
      if (value && value.path) {
        const { path, filename } = value
        plus.hide()
        img.show()
        successIcon.show()
        operation.show()
        img.attr('src', path)
      } else {
        plus.show()
        img.hide()
        successIcon.hide()
        operation.hide()
      }
    },
    folder(value, opt, tar, node) {}
  }
}

export default class Upload extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      fid: '',
      base64: true,
      name: '', // 原生属性: name
      disabled: false, // 原生属性: 禁用(true/false)
      folder: 'file',
      uploadClient: null,
      value: {}, // 基本功能: 值
      height: '', // 基本功能: 尺寸 高度
      width: '' // 基本功能: 尺寸 宽度
    }
    this.events = {
      change: 'onChange',
      click: 'onClick'
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.upload(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    const { input, operationPlus, operationDel, plus } = this.members
    input.on('change', $.proxy(this.change, this))
    operationPlus.on('click', $.proxy(this.click, this))
    plus.on('click', $.proxy(this.click, this))
    operationDel.on('click', $.proxy(this.delete, this))
  }

  fileUploadComplete(data) {
    const { input } = this.members
    this.value = data
    input.val('')
  }

  delete() {
    const { input } = this.members
    input.val('')
    this.value = null
  }

  onChange(e) {
    const file = e.target.files[0]
    this.preView(file)
    if (!this.settings.base64) {
      this.client(file)
    }
  }

  onClick(e) {
    const { input } = this.members
    input.click()
  }

  preView(file) {
    const { img } = this.members
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = (e) => {
      const path = e.target.result
      this.value = { path }
      const result = compressImg(img)
      if (result !== path) {
        this.value = { path }
      }
    }
  }

  client(file) {
    const newDate = new Date()
    const today = [
      String(newDate.getFullYear()),
      String(newDate.getMonth() + 1).padStart(2, '0'),
      String(newDate.getDate()).padStart(2, '0')
    ].join('')
    const fm = fileUpload(file)
    const filename = fm.filename
    const id = this.settings.fid
    const mimetype = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase()
    fm.mimetype = mimetype
    fm.id = id
    fm.path = [this.settings.folder, today].join('/')

    const uploadClient = this.settings.uploadClient
    try {
      uploadClient.upload(fm, {
        md5Computing(prog, total) {},
        md5Complete(md5) {},
        progress(prog, total) {},
        complete(path) {
          this.complete({ id, path, mimetype, filename })
        }
      })
    } catch (error) {
      setTimeout(() => {
        this.delete()
      }, 3000)
      console.error(error)
    }
  }
}
